import type { CSSProperties } from 'react';

// Link uses two URLs: `route` is the Next.js page file (used by the
// client router + data fetch), `path` is the URL the browser displays.
// Pepyaka strips the mount prefix on SSR, so the page files live at
// `/pages/index.tsx`, `/tasks.tsx`, etc. — without `as`, a Link to a
// prefixed URL would 404 on the client side.
// "New conversation" carries ?new=1 so it opens a fresh thread (expanded chat)
// rather than just landing on the bare home page.
export const NEW_CONVERSATION_ROUTE = '/?new=1';

/**
 * Chat History starts OPEN on every surface (Figma "Aug Changes" 493:11832 "Open by default"). One
 * constant for both sidebars so the wide rail and the mobile drawer cannot drift apart again — they
 * disagreed until now. Shared 1:1 with iOS `DrawerContent.historyExpandedByDefault` and Android
 * `CHAT_HISTORY_EXPANDED_BY_DEFAULT`. Not persisted anywhere: it is the initial state, per mount.
 */
export const RECENT_CHATS_DEFAULT_OPEN = true;

export function conversationLink(basePath: string, id: string | undefined): { route: string; path: string } {
  if (!id) return { route: NEW_CONVERSATION_ROUTE, path: `${basePath}/?new=1` };
  // The conversation is always the `?conversation=<id>` query param, never a
  // path segment — so it doesn't change the route. This is the default target
  // (the full chat at `/`); on Symphony, the row's onClick switches the thread
  // in place instead (see useConversationSwitch).
  const idEnc = encodeURIComponent(id);
  return { route: `/?conversation=${idEnc}`, path: `${basePath}/?conversation=${idEnc}` };
}

// Quiet sentence-case section label — matched to the Workspaces label (same size,
// weight, and neutral ink) so the two rail section headers read as one voice.
// Type ramp (Figma "title"): Wix Madefor Text (inherited), SemiBold 600, 14/18,
// -2% tracking.
export const flyoutSectionLabelStyle: CSSProperties = {
  padding: '16px 16px 8px',
  fontSize: 14,
  fontWeight: 'var(--sym-weight-semibold)',
  lineHeight: '18px',
  letterSpacing: '-0.02em',
  color: 'rgb(var(--ink-rgb))',
};
